import Vue from 'vue'
import App from './App.vue'
import VueResource from 'vue-resource'
import VueRouter from 'vue-router'
import Bulma from 'bulma'
import Fragment from 'vue-fragment'
import Buefy from 'buefy'
import { routes } from './routes/routes.js'

Vue.use(Fragment.Plugin)
Vue.use(VueRouter)
Vue.use(Bulma)
Vue.use(Buefy, {
  defaultIconPack: 'fas',
  defaultContainerElement: '#content',
  defaultProgrammaticPromise: true
  // ...
})

Vue.config.productionTip = false

const enrutador = new VueRouter({
  routes: routes,
  mode: "history",
  linkExactActiveClass: "is-active" // active class for *exact* links.
});

// enrutador.beforeEach((to, from, next) => {
//   let isAuthenticated = window.localStorage.getItem("token") || undefined;
//   if (to.name !== "Login" && !isAuthenticated) {
//     next({ name: "Login" });
//   } else {
//     next();
//   }
// });

export const eventBus = new Vue();

Vue.use(VueResource);
Vue.http.options.root = "https://gescama-api.dssm.cl";
Vue.http.interceptors.push((request, next) => {
  var token = window.localStorage.getItem("token") || undefined;
  if (token) {
    request.headers.set("Authorization", "Bearer" + token);
    request.headers.set("Accept", "application/json");
  }
  next((response) => {
    if (response.status === 0) {
      // enrutador.push("/");
    } else if (response.status === 401) {
      eventBus.$emit("value", true);
    }
  });
});

const appVersion = "0.3.1";
const browserVersion = window.localStorage.getItem("appVersion");

if (appVersion !== browserVersion) {
  window.localStorage.setItem("appVersion", appVersion);
  window.location.reload(true);
}

Vue.config.productionTip = false;

Vue.mixin({
  methods: {
    toast(message, type) {
      this.$buefy.toast.open({
        message: message,
        type: type,
      });
    },
    getUrlFile(file_name){
      return `${Vue.http.options.root}/${file_name}`
    },
    getCurrentUserLoggedIn() {
      return JSON.parse(window.localStorage.getItem("user"));
    },
  },
});

new Vue({
  router: enrutador,
  render: (h) => h(App),
}).$mount("#app");